import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import SocialLinks from "@/components/SocialLinks";
import { useLang } from "@/lib/i18n";

export default function Footer() {
  const { tr } = useLang();
  return (
    <footer className="relative border-t border-aqua/10 bg-deep/40" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 md:px-10 py-16 md:py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo size={40} />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-foam/60">
              {tr("École Française de Janzu — transmission certifiée du soin aquatique. Bassins privés chauffés à 33 °C, à La Rochelle, à La Réunion et à Maurice.")}
            </p>
            <SocialLinks className="mt-7" />
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-aqua">{tr("Explorer")}</p>
            <ul className="mt-5 space-y-3 text-sm text-foam/70">
              <li><Link to="/" className="hover:text-foam transition-colors">{tr("Accueil")}</Link></li>
              <li><Link to="/philosophie" className="hover:text-foam transition-colors">{tr("Philosophie")}</Link></li>
              <li><Link to="/ambassadeurs" className="hover:text-foam transition-colors" data-testid="footer-ambassadeurs-link">{tr("Ambassadeurs")}</Link></li>
              <li><Link to="/cgv" className="hover:text-foam transition-colors" data-testid="footer-cgv-link">{tr("CGV")}</Link></li>
              <li><Link to="/mentions-legales" className="hover:text-foam transition-colors" data-testid="footer-mentions-link">{tr("Mentions légales")}</Link></li>
              <li><Link to="/galerie" className="hover:text-foam transition-colors" data-testid="footer-gallery-link">{tr("Galerie")}</Link></li>
              <li><Link to="/faq" className="hover:text-foam transition-colors">{tr("FAQ")}</Link></li>
              <li><Link to="/contact" className="hover:text-foam transition-colors">{tr("Contact")}</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-aqua">{tr("Cursus")}</p>
            <ul className="mt-5 space-y-3 text-sm text-foam/70">
              <li><Link to="/formations/janzu-1-surface" className="hover:text-foam transition-colors">Janzu I — Surface</Link></li>
              <li><Link to="/formations/janzu-2-immersion" className="hover:text-foam transition-colors">Janzu II — Immersion</Link></li>
              <li><Link to="/formations/janzu-3-accompagnement" className="hover:text-foam transition-colors">Janzu III — Accompagnement</Link></li>
              <li><Link to="/formations/master-pro" className="hover:text-foam transition-colors">Master Pro</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-aqua">{tr("L'école")}</p>
            <ul className="mt-5 space-y-3 text-sm text-foam/70">
              <li><Link to="/certification" className="hover:text-foam transition-colors">{tr("Certification Qualiopi")}</Link></li>
              <li><Link to="/presse" className="hover:text-foam transition-colors">{tr("Presse & reportage TF1")}</Link></li>
              <li><Link to="/temoignages" className="hover:text-foam transition-colors">{tr("Témoignages")}</Link></li>
              <li><a href="https://www.janzu.fr" target="_blank" rel="noreferrer" className="hover:text-foam transition-colors" data-testid="footer-official-site">{tr("janzu.fr — site officiel")}</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-col md:flex-row justify-between gap-3 border-t border-aqua/10 pt-8 text-xs text-foam/40 font-mono">
          <p>© 2026 OJANZU — {tr("École Française de Janzu")}</p>
          <p>{tr("Le silence a une profondeur.")}</p>
        </div>
      </div>
    </footer>
  );
}
